module.exports = __webpack_public_path__ + "h5/img/live-logo.b114bcb5.gif";